// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"6d10d234","335":"13dbeba1","943":"5e04785d"}[chunkId] + ".chunk.js";
};